export default function SnailOnly({ className, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-5 2 45 40"
      aria-hidden="true"
      className={className}
      style={style}
      fill="none"
    >
      <path
        d="M 14,32 C 6,32 4,22 4,16 C 4,8 12,4 20,4 C 28,4 36,10 36,18 C 36,28 30,36 22,36 C 18,38 14,36 14,26"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M 18,28 C 12,24 10,16 12,10 C 14,8 20,6 24,10 C 28,16 26,24 22,26"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M 14,32 C 8,35 2,35 -2,32"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M 1,31 L -2,22"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <circle cx="-2" cy="21" r="1.2" fill="currentColor" />
      <path
        d="M 2,30 L 0,20"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <circle cx="0" cy="19" r="1.2" fill="currentColor" />
    </svg>
  );
}
